import { render, staticRenderFns } from "./roleView.vue?vue&type=template&id=8694159a&scoped=true&"
import script from "./roleView.vue?vue&type=script&lang=js&"
export * from "./roleView.vue?vue&type=script&lang=js&"
import style0 from "./roleView.vue?vue&type=style&index=0&id=8694159a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8694159a",
  null
  
)

export default component.exports